import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListGrants$ } from "../schemas/schemas_0";
export { $Command };
export class ListGrantsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "ListGrants", {})
    .n("KMSClient", "ListGrantsCommand")
    .sc(ListGrants$)
    .build() {
}
